import React, { useState, useEffect } from "react";
import styles from './styles.module.scss';

const ScamAlertBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const bannerClosed = localStorage.getItem('scamAlertBannerClosed');
    if (!bannerClosed) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
    localStorage.setItem('scamAlertBannerClosed', 'true');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;


  return (
    <div className={styles.scamAlertBanner}>
      <div className={styles.content}>
        <svg className={styles.icon} viewBox="0 0 24 24">
          <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
        </svg>
        <span className={styles.text}>
          <strong>Stay vigilant:</strong> Never share personal info with unverified contacts. Your data security is our priority.{' '}
          <a
            href="https://www.twrecruitment.com/recruitment-scam-alert"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            Learn more &gt;
          </a>
        </span>
      </div>
      <button
        onClick={handleClose}
        className={styles.closeButton}
        aria-label="Close alert"
      >
        Close
      </button>
    </div>
  );
};

export default ScamAlertBanner;
